import { VcardData, VcardStatus } from '../typings/banners';
import { ValidationErrorData } from '../typings/common';
import { VisitingCardValue } from '../typings/VisitingCardEditor';

export const GET_VCARDS_FOR_BANNERS_EDIT = 'GET_VCARDS_FOR_BANNERS_EDIT';
export type GET_VCARDS_FOR_BANNERS_EDIT = typeof GET_VCARDS_FOR_BANNERS_EDIT;

export interface GetVCardsForBannersEdit {
    type: GET_VCARDS_FOR_BANNERS_EDIT;
    login: string;
    vCardIds: Array<string>;
}

export function getVCardsForBannersEdit(
    login: string,
    vCardIds: Array<string>
): GetVCardsForBannersEdit {
    return {
        type: GET_VCARDS_FOR_BANNERS_EDIT,
        login,
        vCardIds
    };
}

export const OPEN_VCARD_EDITOR = 'OPEN_VCARD_EDITOR';
export type OPEN_VCARD_EDITOR = typeof OPEN_VCARD_EDITOR;

export interface OpenVCardEditor {
    type: OPEN_VCARD_EDITOR;
    editorId: string;
    vCardId: string;
    savedValue: VisitingCardValue;
}

export function openVCardEditor(
    editorId: string,
    vCardId: string,
    savedValue: VisitingCardValue
): OpenVCardEditor {
    return {
        type: OPEN_VCARD_EDITOR,
        editorId,
        vCardId,
        savedValue
    };
}

export const CLOSE_VCARD_EDITOR = 'CLOSE_VCARD_EDITOR';
export type CLOSE_VCARD_EDITOR = typeof CLOSE_VCARD_EDITOR;

export interface CloseVCardEditor {
    type: CLOSE_VCARD_EDITOR;
    editorId: string;
}

export function closeVCardEditor(editorId: string): CloseVCardEditor {
    return {
        type: CLOSE_VCARD_EDITOR,
        editorId
    };
}

export const TOGGLE_VCARD_SHORT_VERSION_FLAG =
    'TOGGLE_VCARD_SHORT_VERSION_FLAG';
export type TOGGLE_VCARD_SHORT_VERSION_FLAG = typeof TOGGLE_VCARD_SHORT_VERSION_FLAG;

export interface ToggleVCardShortVersionFlag {
    type: TOGGLE_VCARD_SHORT_VERSION_FLAG;
    editorId: string;
}

export function toggleVCardShortVersionFlag(
    editorId: string
): ToggleVCardShortVersionFlag {
    return {
        type: TOGGLE_VCARD_SHORT_VERSION_FLAG,
        editorId
    };
}

export const TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH =
    'TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH';
export type TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH = typeof TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH;

export interface ToggleVCardNotShowMetroInSearchFlag {
    type: TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH;
    editorId: string;
}

export function toggleVCardNotShowMetroInSearchFlag(
    editorId: string
): ToggleVCardNotShowMetroInSearchFlag {
    return {
        type: TOGGLE_VCARD_NOT_SHOW_METRO_IN_SEARCH,
        editorId
    };
}

export const FETCH_VCARD_METRO_STATION = 'FETCH_VCARD_METRO_STATION';
export type FETCH_VCARD_METRO_STATION = typeof FETCH_VCARD_METRO_STATION;

export interface FetchVCardMetroStation {
    type: FETCH_VCARD_METRO_STATION;
    editorId: string;
    x: number;
    y: number;
}

export function fetchVCardMetroStation(
    editorId: string,
    x: number,
    y: number
): FetchVCardMetroStation {
    return {
        type: FETCH_VCARD_METRO_STATION,
        editorId,
        x,
        y
    };
}

export const UPDATE_DRAFT_VCARD = 'UPDATE_DRAFT_VCARD';
export type UPDATE_DRAFT_VCARD = typeof UPDATE_DRAFT_VCARD;

export interface UpdateDraftVCard {
    type: UPDATE_DRAFT_VCARD;
    editorId: string;
    vCard: VcardData;
    vCardStatus?: VcardStatus;
}

export function updateDraftVCard(
    editorId: string,
    vCard: VcardData,
    vCardStatus?: VcardStatus
): UpdateDraftVCard {
    return {
        type: UPDATE_DRAFT_VCARD,
        editorId,
        vCard,
        vCardStatus
    };
}

export const RESET_VCARD = 'RESET_VCARD';
export type RESET_VCARD = typeof RESET_VCARD;

export interface ResetVCard {
    type: RESET_VCARD;
    editorId: string;
    savedValue: VisitingCardValue;
}

export function resetVCard(
    editorId: string,
    savedValue: VisitingCardValue
): ResetVCard {
    return {
        type: RESET_VCARD,
        editorId,
        savedValue
    };
}

export const SAVE_VCARDS = 'SAVE_VCARDS';
export type SAVE_VCARDS = typeof SAVE_VCARDS;

export interface SaveVCards {
    type: SAVE_VCARDS;
    editorId: string;
}

export function saveVCards(editorId: string): SaveVCards {
    return {
        type: SAVE_VCARDS,
        editorId
    };
}

export const SAVE_SUCCESS_FOR_EDITOR_VCARDS = 'SAVE_SUCCESS_FOR_EDITOR_VCARDS';
export type SAVE_SUCCESS_FOR_EDITOR_VCARDS = typeof SAVE_SUCCESS_FOR_EDITOR_VCARDS;

export interface SaveSuccessForEditorVCards {
    type: SAVE_SUCCESS_FOR_EDITOR_VCARDS;
    editorIds: string[];
    vCardIds: string[];
}

export function saveSuccessForEditorVCards(
    editorIds: string[],
    vCardIds: string[]
): SaveSuccessForEditorVCards {
    return {
        type: SAVE_SUCCESS_FOR_EDITOR_VCARDS,
        editorIds,
        vCardIds
    };
}

export const UPDATE_VCARDS_ERRORS = 'UPDATE_VCARDS_ERRORS';
export type UPDATE_VCARDS_ERRORS = typeof UPDATE_VCARDS_ERRORS;

export interface UpdateVCardsErrors {
    type: UPDATE_VCARDS_ERRORS;
    editorIds: string[];
    updateEditorIds: string[];
    errors: Record<string, ValidationErrorData[]>;
}

export function updateVCardsErrors(
    editorIds: string[],
    updateEditorIds: string[],
    errors: Record<string, ValidationErrorData[]>
): UpdateVCardsErrors {
    return {
        type: UPDATE_VCARDS_ERRORS,
        editorIds,
        updateEditorIds,
        errors
    };
}

export const UPDATE_VISITING_CARD_ERRORS = 'UPDATE_VISITING_CARD_ERRORS';
export type UPDATE_VISITING_CARD_ERRORS = typeof UPDATE_VISITING_CARD_ERRORS;

export interface UpdateVisitingCardsErrors {
    type: UPDATE_VISITING_CARD_ERRORS;
    editorId: string;
    errors: ValidationErrorData[];
}

export function updateVisitingCardsErrors(
    editorId: string,
    errors: ValidationErrorData[]
): UpdateVisitingCardsErrors {
    return {
        type: UPDATE_VISITING_CARD_ERRORS,
        editorId,
        errors
    };
}

export const REMOVE_VCARD_ERROR = 'REMOVE_VCARD_ERROR';
export type REMOVE_VCARD_ERROR = typeof REMOVE_VCARD_ERROR;

export interface RemoveVCardErrors {
    type: REMOVE_VCARD_ERROR;
    editorId: string;
    paths: Array<string>;
}

export function removeVCardErrors(
    editorId: string,
    paths: Array<string>
): RemoveVCardErrors {
    return {
        type: REMOVE_VCARD_ERROR,
        editorId,
        paths
    };
}

export const CLEAR_VCARD = 'CLEAR_VCARD';
export type CLEAR_VCARD = typeof CLEAR_VCARD;

export interface ClearVCard {
    type: CLEAR_VCARD;
    editorIds: string[];
}

export function clearVCard(editorIds: string[]): ClearVCard {
    return {
        type: CLEAR_VCARD,
        editorIds
    };
}

export const UPDATE_VCARD_METRO_STATION_INFO =
    'UPDATE_VCARD_METRO_STATION_INFO';
export type UPDATE_VCARD_METRO_STATION_INFO = typeof UPDATE_VCARD_METRO_STATION_INFO;

export interface UpdateVCardMetroStationInfo {
    type: UPDATE_VCARD_METRO_STATION_INFO;
    metroStationId: string;
    metroStationName: string;
    editorId: string;
}

export function updateVCardMetroStationInfo(
    metroStationId: string,
    metroStationName: string,
    editorId: string
): UpdateVCardMetroStationInfo {
    return {
        type: UPDATE_VCARD_METRO_STATION_INFO,
        metroStationId,
        metroStationName,
        editorId
    };
}

export type VisitingCardEditorAction =
    | GetVCardsForBannersEdit
    | OpenVCardEditor
    | CloseVCardEditor
    | ToggleVCardShortVersionFlag
    | ToggleVCardNotShowMetroInSearchFlag
    | UpdateDraftVCard
    | ResetVCard
    | SaveVCards
    | FetchVCardMetroStation
    | UpdateVCardMetroStationInfo
    | SaveSuccessForEditorVCards
    | UpdateVCardsErrors
    | RemoveVCardErrors
    | ClearVCard
    | UpdateVisitingCardsErrors;
